import { LEAD_TYPE_ARRAY } from './sf_constants'
import { capitalizeFirstLetter } from './sf_utils'
import {
  LEAD_MARKETPLACE_PRODUCT_LABEL,
  NAME_OF_LEAD_TYPES,
  NAME_OF_PRODUCT_TYPES,
  PRODUCT_TYPE_IDS,
  getProductTypeByName
} from './sf_constants'

export const isLeadMarketplaceProduct = (productTypeName, isLeadMarketplaceEnabled) => (
  productTypeName?.toLowerCase() === NAME_OF_PRODUCT_TYPES.LEADS && isLeadMarketplaceEnabled
)

export const getCampaignProductLabel = (productTypeName, isLeadMarketplaceEnabled) => (
  !isLeadMarketplaceProduct(productTypeName, isLeadMarketplaceEnabled)
    ? capitalizeFirstLetter(productTypeName)
    : LEAD_MARKETPLACE_PRODUCT_LABEL
)

export const getGoalProductLabel = (productTypeName, isLeadMarketplaceEnabled) => {
  if (isLeadMarketplaceProduct(productTypeName, isLeadMarketplaceEnabled)) {
    return LEAD_MARKETPLACE_PRODUCT_LABEL
  }

  if (isLeadMarketplaceEnabled && productTypeName === NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS) {
    return 'Quote Funnels'
  }

  return capitalizeFirstLetter(productTypeName)
}

export const getAvailableLeadTypes = (productTypeName, isLeadMarketplaceEnabled) => {
  if (!isLeadMarketplaceProduct(productTypeName, isLeadMarketplaceEnabled)) {
    return LEAD_TYPE_ARRAY
  }

  return LEAD_TYPE_ARRAY.filter(
    leadType => [
      NAME_OF_LEAD_TYPES.AUTO,
      NAME_OF_LEAD_TYPES.HOME,
      NAME_OF_LEAD_TYPES.COMMERCIAL,
    ].includes(leadType.value)
  )
}

export const getGoalAdminDashboardProductOptions = (isLeadMarketplaceEnabled) => {
  const options = [
    { value: NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS, label: 'Quote Funnels' }
  ]

  if (isLeadMarketplaceEnabled) {
    options.push({
      value: NAME_OF_PRODUCT_TYPES.LEADS,
      label: getGoalProductLabel(NAME_OF_PRODUCT_TYPES.LEADS, isLeadMarketplaceEnabled)
    })
  }

  return options
}

export const getGoalAdminClientProductOptions = (
  productOptions,
  isGoalBrand,
  isLeadMarketplaceEnabled
) => {
  if (!isGoalBrand || !isLeadMarketplaceEnabled) {
    return productOptions
  }

  return [
    ...productOptions,
    { value: PRODUCT_TYPE_IDS.LEADS, label: LEAD_MARKETPLACE_PRODUCT_LABEL }
  ]
}

export const getAdminDashboardProductTypeId = (productTypeName) => (
  getProductTypeByName(productTypeName)?.id
  ?? (productTypeName === NAME_OF_PRODUCT_TYPES.LEADS ? PRODUCT_TYPE_IDS.LEADS : null)
)

export const isAllProductsSelection = (selectedProduct) => (
  selectedProduct?.value === ''
)

export const isGoalDomainSourceDimension = (
  productTypeName,
  isGoal,
  isLeadMarketplaceEnabled
) => isGoal && isLeadMarketplaceProduct(productTypeName, isLeadMarketplaceEnabled)

export const shouldShowAdminSourceDimension = (
  selectedProduct,
  isGoal,
  isLeadMarketplaceEnabled,
  isSourceTypeFilterEnabled
) => {
  const productTypeName = selectedProduct?.value

  return isGoalDomainSourceDimension(productTypeName, isGoal, isLeadMarketplaceEnabled) ||
    (isSourceTypeFilterEnabled && [
      NAME_OF_PRODUCT_TYPES.CALLS,
      NAME_OF_PRODUCT_TYPES.LEADS
    ].includes(productTypeName)) ||
    isAllProductsSelection(selectedProduct) ||
    [
      NAME_OF_PRODUCT_TYPES.CLICKS,
      NAME_OF_PRODUCT_TYPES.SYNDI_CLICKS,
      NAME_OF_PRODUCT_TYPES.QUOTE_FUNNELS
    ].includes(productTypeName)
}

export const getAdminSourceDimensionLabel = (
  productTypeName,
  isGoal,
  isLeadMarketplaceEnabled
) => (
  isGoalDomainSourceDimension(productTypeName, isGoal, isLeadMarketplaceEnabled)
    ? 'Domain Source'
    : 'Source Type'
)

export const getGoalDomainSourceQueryParams = (
  productTypeName,
  isGoal,
  isLeadMarketplaceEnabled,
  selectedAccounts = [],
  selectedBrands = [],
  selectedCampaigns = []
) => {
  if (!isGoalDomainSourceDimension(productTypeName, isGoal, isLeadMarketplaceEnabled)) {
    return null
  }

  const optionalIds = options => {
    const ids = options.map(option => option.value)
    return ids.length ? ids : null
  }

  return {
    product_type_ids: [getAdminDashboardProductTypeId(productTypeName)],
    account_ids: optionalIds(selectedAccounts),
    brand_ids: optionalIds(selectedBrands),
    campaign_ids: optionalIds(selectedCampaigns)
  }
}
